import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@emotion/react';
import Modal from '@/components/atoms/Modal';
import { Button } from '@/components/atoms/Button';
import { SVGIcons } from '@/components/atoms/Icon/SVGIcon';
import { Text } from '@/components/atoms/Text';
import { RestaurantShift } from '@/services/innovorder/restaurant/restaurant.type';

export type DeleteShiftModalProps = {
    shift: RestaurantShift | null;
    isOpen: boolean;
    onHide: () => void;
    onSubmit: () => void;
    isLoading?: boolean;
};

export const DeleteShiftModal: React.FunctionComponent<React.PropsWithChildren<DeleteShiftModalProps>> = ({
    shift,
    isOpen,
    onHide,
    onSubmit,
    isLoading,
}) => {
    const theme = useTheme();

    if (shift?.isDefault) {
        return (
            <Modal
                isOpen={isOpen}
                onHide={onHide}
                width={328}
                title="shift.delete.modal.title"
                icon={SVGIcons.INFO}
                iconColor={theme.color.bloodyMary}
                buttons={
                    <Button onClick={onHide} buttonType="primary">
                        <FormattedMessage id="button.ok" />
                    </Button>
                }
            >
                <FormattedMessage id="shift.delete.modal.defaultBlocked" />
            </Modal>
        );
    }

    return (
        <Modal
            isOpen={isOpen}
            onHide={onHide}
            width={328}
            title="shift.delete.modal.warning"
            icon={SVGIcons.INFO}
            iconColor={theme.color.bloodyMary}
            shouldNotHideOnClickOutside={isLoading}
            buttons={
                <Button
                    onClick={onSubmit}
                    buttonType="primary"
                    isLoading={isLoading}
                    disabled={isLoading}
                    data-testid="shifts-delete-confirm"
                >
                    <FormattedMessage id="button.delete" />
                </Button>
            }
        >
            <Text text="shift.delete.modal.confirmDelete" />
        </Modal>
    );
};
